import {
  DocumentNode,
  MutationFunctionOptions,
  MutationTuple,
  useMutation,
} from '@apollo/client';

export const createUseMutationHook = <T, U>(
  mutation: DocumentNode,
  // Optionally pass in a reducer to hydrate the options passed into the function
  // with some default properties (maybe we always prefer certain refetchQueries
  // with this mutation, etc.)
  hydrateOptions?: (
    mutationHookOptions?: MutationFunctionOptions<T, U>,
    variables?: U
  ) => MutationFunctionOptions<T, U>
) => {
  return function useMutationCustom(): MutationTuple<T, U> {
    const [mutate, ...rest] = useMutation<T, U>(mutation);

    return [
      (options?: MutationFunctionOptions<T, U>) => {
        return mutate(hydrateOptions ? hydrateOptions(options) : options);
      },
      ...rest,
    ];
  };
};
